module.exports = __webpack_public_path__ + "img/carlos2.e9bbe326.jpg";